import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { autorun, makeObservable, obx, createModuleEventBus } from '@alilc/lowcode-editor-core';
import { isSimulatorRenderer } from './renderer';
var UNSET = Symbol('unset');
// master 进程
//  0. 初始化该对象，因为需要响应变更发生在 master 进程
//  1. 提供消费数据或数据提供器，比如 Asset 资源，如果不是数据提供器，会持续提供
//  2. 收到成功通知
// renderer 进程
//  1. 持续消费，并持续监听数据
//  2. 消费
// 这里涉及俩个自定义项
//  1. 被消费数据协议
//  2. 消费机制（渲染进程自定 + 传递进入）
var ResourceConsumer = (_dec = obx.ref, (_class = /*#__PURE__*/function () {
  function ResourceConsumer(provider, consumer) {
    var _this = this;
    this.consumer = consumer;
    this.emitter = createModuleEventBus('ResourceConsumer');
    _initializerDefineProperty(this, "_data", _descriptor, this);
    this._providing = void 0;
    this._consuming = void 0;
    this._firstConsumed = false;
    this.resolveFirst = void 0;
    makeObservable(this);
    this._providing = autorun(function () {
      _this._data = provider();
    });
  }
  var _proto = ResourceConsumer.prototype;
  _proto.consume = function consume(consumerOrRenderer) {
    var _this2 = this;
    if (this._consuming) {
      return;
    }
    var consumer;
    if (isSimulatorRenderer(consumerOrRenderer)) {
      if (!this.consumer) {
        // TODO: throw error
        return;
      }
      var rendererConsumer = this.consumer;
      consumer = function consumer(data) {
        return rendererConsumer(consumerOrRenderer, data);
      };
    } else {
      consumer = consumerOrRenderer;
    }
    this._consuming = autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_this2._data === UNSET)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return consumer(_this2._data);
          case 4:
            // TODO: catch error and report
            if (_this2.resolveFirst) {
              _this2.resolveFirst();
            } else {
              _this2._firstConsumed = true;
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
  };
  _proto.dispose = function dispose() {
    if (this._providing) {
      this._providing();
    }
    if (this._consuming) {
      this._consuming();
    }
    this.emitter.removeAllListeners();
  };
  _proto.waitFirstConsume = function waitFirstConsume() {
    var _this3 = this;
    if (this._firstConsumed) {
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      _this3.resolveFirst = resolve;
    });
  };
  return ResourceConsumer;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return UNSET;
  }
})), _class));
export { ResourceConsumer as default };